import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnfold = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 40,
	width: 40,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14.542 14.625 12.625 12.708 20 5.333 27.375 12.708 25.458 14.625 20 9.167ZM20 34.792 12.625 27.375 14.542 25.458 20 30.958 25.458 25.458 27.375 27.375Z" })
});
export { SvgUnfold as ReactComponent };
